import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { IdentifiedFieldIssue } from '../../../IFITrackerContext/types'
import { Report, alphabeticalCompare } from 'shared'
import { HelpMessage } from 'utils/constants'
import { getReport } from '../../../utils/getReport'
import { SortOptions } from 'components/CIMSTable/CIMSColumn/types/sort'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'
import CIMSLink from 'components/CIMSLink'

export function useReportID(
  options: Required<Pick<SortOptions<IdentifiedFieldIssue>, 'priority'>>
): CIMSSingleColumn<IdentifiedFieldIssue> {
  const deps = useReportURLDependencies()
  return {
    title: 'Report ID',
    render: (record) => {
      const report = getReport(record) ?? record.densityTest
      if (!report) return null
      let href
      if (report.__typename === 'DensityTest') return report.testId
      else if (report.__typename === 'AsphaltLot')
        href = Report.AsphaltLot.toURL({ ...report, ...deps })
      else if (report.__typename === 'ConcreteTest')
        href = Report.ConcreteCylinderIASheet.toURL({ ...report, ...deps })
      else if (report.__typename === 'DailyInspectionControlPoint')
        href = Report.ControlPoint.toURL({ ...report, ...deps })
      else if (report.__typename === 'DailyInspectionInspection')
        href = Report.Inspection.toURL({ ...report, ...deps })
      else if (report.__typename === 'DailyInspectionPunchList')
        href = Report.PunchList.toURL({ ...report, ...deps })
      else if (report.__typename === 'Lot')
        href = Report.DensityLot.toURL({ ...report, ...deps })
      return (
        <CIMSLink external href={href}>
          {record.reportName}
        </CIMSLink>
      )
    },
    width: 150,
    help: HelpMessage.IdentifiedFieldIssues.IFITracker.ReportID,
    sort: {
      ...options,
      with: 'callback',
      default: 'ascend',
      onCompare: (a, b) => alphabeticalCompare(a.reportName, b.reportName),
    },
    filter: {
      type: 'search',
      with: 'callback',
      onFilter: (value, { reportName }) =>
        reportName?.toLowerCase().includes(value.toString().toLowerCase()) ??
        false,
    },
  }
}
